import { render, staticRenderFns } from "./money.vue?vue&type=template&id=288c9d90&"
import script from "./money.vue?vue&type=script&lang=js&"
export * from "./money.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports